import React, { FC } from "react";
import { Routes, Route, Link } from "react-router-dom";

import UseGoods from "./pages/goods";
import UseOrderList from "./pages/orderList";
import UsePayResult from "./pages/payResult";
import "./App.css";

const UseApp: FC = () => {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<UseGoods />}></Route>
        <Route path="/orderlist" element={<UseOrderList />}></Route>
        <Route path="/payResult" element={<UsePayResult />}></Route>
      </Routes>
    </div>
  );
};

export default UseApp;
